import {
  IonApp,
  IonContent,
  IonPage,
  IonRouterOutlet,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route } from "react-router-dom";
/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";
/* Optional CSS utils that can be commented out */
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/typography.css";

import Account from "./components/Account/Account";
import Book from "./components/Book/Book";
import Competence from "./components/Competence/Competence";
import PageNotFound from "./components/ErrorComponent/PageNotFound/PageNotFound";
import Generique from "./components/Generiques/Generique";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import TechnoList from "./components/TechnoList/TechnoList";
import VideoDisplay from "./components/Video/Video";
import VideoGen from "./components/Video/VideoGen";
import Welcome from "./components/Welcome/Welcome";
/* Theme variables */
import { useEffect } from "react";
import Feed from "./components/Feed/Feed";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ForgotPassword/ResetPassword";
import NotValid from "./components/NotValid/NotValid";
import "./components/generalCSS/stylesheet.css";
import FormalPratique from "./pages/FormalPratique/FormalPratique";
import FormalPratiqueSkill from "./pages/FormalPratique/FormalPratiqueSkill";
import FormalPratiqueTheme from "./pages/FormalPratique/FormalPratiqueTheme";
import { makePATCHRequest } from "./request/rawRequest";
import "./theme/variables.css";

setupIonicReact();

export const getMonday = () => {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const date = now.getDate();
  const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(now.getFullYear(), now.getMonth(), date - diff);
  return monday;
};

const App: React.FC = () => {
  const pathLogo = "assets/logo/deliceo_logo.jpg";
  const timeToAdd = 30000;

  const handleUserTimeAdder = async () => {
    if (localStorage.getItem("authToken")) {
      if (
        !window.location.pathname.includes("/notvalid") &&
        !window.location.pathname.includes("/account")
      ) {
        await makePATCHRequest("/time", {
          time: timeToAdd,
          week_nb: getMonday().getTime(),
        });
      }
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleUserTimeAdder();
    }, timeToAdd);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <IonApp>
      <IonPage color="primary">
        <IonContent className="main-container">
          <IonReactRouter>
            <IonRouterOutlet>
              {/* if not token go to home */}

              <Route exact path="/forgotPassword">
                <ForgotPassword pathLogo={pathLogo} />
              </Route>
              <Route exact path="/resetPassword">
                <ResetPassword pathLogo={pathLogo} />
              </Route>

              <Route exact path="/account">
                {localStorage.getItem("authToken") ? (
                  <Account pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/competences">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") &&
                localStorage.getItem("pole") ? (
                  <Competence endpoint="" pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/feed">
                {localStorage.getItem("authToken") ? (
                  <Feed />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/video">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") &&
                localStorage.getItem("pole") ? (
                  <VideoDisplay endpoint="" pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/generiques">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") &&
                localStorage.getItem("pole") ? (
                  <Generique endpoint="" pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/videogen">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") &&
                localStorage.getItem("pole") ? (
                  <VideoGen endpoint="" pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/book">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") ? (
                  <Book pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/formalPratique">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") ? (
                  <FormalPratique />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/formalPratique/:id/:id">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") ? (
                  <FormalPratiqueTheme />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/formalPratique/:id">
                {localStorage.getItem("authToken") &&
                localStorage.getItem("techno") ? (
                  <FormalPratiqueSkill />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/welcome">
                {localStorage.getItem("authToken") ? (
                  <Welcome endpoint="" pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              <Route exact path="/notvalid">
                {localStorage.getItem("authToken") ? (
                  <NotValid pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/home" />
                )}
              </Route>

              {/* if authToken go to welcome */}

              <Route exact path="/login">
                {localStorage.getItem("authToken") ? (
                  <Redirect to="/welcome" />
                ) : (
                  <TechnoList endpoint="" pathLogo={pathLogo} />
                )}
              </Route>

              <Route exact path="/register">
                {localStorage.getItem("authToken") ? (
                  <Redirect to="/welcome" />
                ) : (
                  <Register endpoint="" pathLogo={pathLogo} />
                )}
              </Route>

              <Route exact path="/home">
                {localStorage.getItem("authToken") ? (
                  <Redirect to="/welcome" />
                ) : (
                  <Login endpoint="" pathLogo={pathLogo} />
                )}
              </Route>

              <Route exact path="/">
                <Redirect to="/home" />
              </Route>

              <Route exact path="/404">
                <PageNotFound />
              </Route>

              {/* keep this last */}
              <Route>
                <Redirect to="/404" />
              </Route>
            </IonRouterOutlet>
          </IonReactRouter>
        </IonContent>
      </IonPage>
    </IonApp>
  );
};

export default App;
